import * as React from "react";
import type { SVGProps } from "react";
const SvgMallIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M14 2.38A5.077 5.077 0 0 0 8.929 7.45v1.8H4.805a.42.42 0 0 0-.417.374L2.674 25.154a.42.42 0 0 0 .417.466h21.817a.42.42 0 0 0 .418-.466l-1.714-15.53a.42.42 0 0 0-.418-.373h-4.123v-1.8A5.077 5.077 0 0 0 14 2.38M9.769 7.45A4.236 4.236 0 0 1 14 3.22a4.236 4.236 0 0 1 4.231 4.231v1.8H9.77zm13.05 2.64 1.62 14.689H3.56L5.182 10.09h3.747v2.15a.42.42 0 1 0 .84 0v-2.15h8.463v2.15a.42.42 0 1 0 .84 0v-2.15z"
    />
  </svg>
);
export default SvgMallIcon;
